// adapted from https://unpkg.com/fbjs@0.8.17/lib/performance.js

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export default window.performance || {};
